import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecebimentoService } from '../../shared/services/recebimento.service';
import { ToastService } from '../../shared/services/toast.service';
import { LocalContextService } from '../../shared/services/local-context.service';
import { ToastState as ts } from '../../shared/enums/toast-state.enum';
import { TegelModule } from '@scania/tegel-angular-17';
import { ControlPass } from '../control-pass/models/control-pass';
import { DialogControlPassComponent } from '../control-pass/dialog-control-pass/dialog-control-pass.component';
import { MatDialog } from '@angular/material/dialog';
import { ImpressoraService } from '../../shared/services/impressora.service';

@Component({
  selector: 'app-totem',
  imports: [TegelModule],
  templateUrl: './totem.component.html',
  styleUrl: './totem.component.scss',
})
export class TotemComponent implements OnInit {
  currentLocalId: number | null = null;

  private readonly UNCONFIGURED_TOTEM_MESSAGE =
    'Totem sem local configurado. Solicite ajuda ao atendimento.';
  private readonly GENERIC_OPERATION_ERROR_MESSAGE =
    'Não foi possível concluir a operação. Tente novamente ou procure o atendimento.';

  constructor(
    private router: Router,
    private recebimentoService: RecebimentoService,
    private toast: ToastService,
    private localContextService: LocalContextService,
    private dialog: MatDialog,
    private impressoraService: ImpressoraService,
  ) {
    this.localContextService.currentLocalId$.subscribe((id) => {
      if (id) this.currentLocalId = +id;
    });
  }
  ngOnInit(): void {
    this.localContextService.currentLocalId$.subscribe({
      next: (localId) => {
        this.currentLocalId = localId ? +localId : null;
      },
    });
  }

  goToBiometry() {
    this.router.navigate(['/totem/biometria']);
  }

  generatePass() {
    if (this.currentLocalId === null) {
      this.toast.showToast(ts.error, this.UNCONFIGURED_TOTEM_MESSAGE);
      return;
    }

    const localId = this.currentLocalId;
    const payload = {
      localId,
      driverId: null,
    };

    this.recebimentoService.generatePassAndReceiving(payload).subscribe({
      next: (result) => {
        if (result.success) {
          this.printGeneratedPass(result.content, localId);
        }
      },
      error: () => {
        this.toast.showToast(ts.error, this.GENERIC_OPERATION_ERROR_MESSAGE);
      },
    });
  }

  private printGeneratedPass(item: ControlPass, localId: number) {
    this.impressoraService.printTicket(item.senha, localId).subscribe({
      next: () => {
        this.toast.showToast(
          ts.success,
          'Senha gerada e impressa com sucesso.',
          'CONTROL PASS',
        );
        this.openDialogDetails(item);
      },
      error: () => {
        this.toast.showToast(
          ts.warning,
          `Sua senha é ${item.senha}. A impressão não foi concluída. Anote o número e procure o atendimento.`,
          'CONTROL PASS',
        );
        this.openDialogDetails(item);
      },
    });
  }

  private openDialogDetails(item: ControlPass) {
    this.dialog.open(DialogControlPassComponent, {
      data: item,
    });
  }
}
